import { useWidgetContext } from '../Widget.hooks'
import { WidgetHeaderContent } from '../WidgetHeaderContent'
import { WidgetHeaderSkeleton } from '../WidgetHeaderSkeleton'

import * as styles from './WidgetHeader.module.css'

function WidgetHeader({
  Content = WidgetHeaderContent,
  Skeleton = WidgetHeaderSkeleton,
  className = styles.WidgetHeader,
  contentProps,
  skeletonProps,
  title,
}) {
  const { isSkeleton } = useWidgetContext()

  return (
    <div className={className}>
      {isSkeleton ? (
        <Skeleton {...skeletonProps} />
      ) : (
        <Content {...contentProps} title={title} />
      )}
    </div>
  )
}

export default WidgetHeader
